import React, { useCallback, useEffect, useRef, useState } from "react";
import ComponentStyle from "@/styles/components/custom-cv-load/_index.module.scss";
import { useTranslation } from "react-i18next";

export function IframeGoogleDoc({ url, isPublic }) {
  const [iframeTimeoutId, setIframeTimeoutId] = useState(null);
  const [showLoading, setShowLoading] = useState(true);
  const iframeRef = useRef(null);
  const { t } = useTranslation();
  const getIframeLink = useCallback(() => {
    return `https://docs.google.com/gview?url=${encodeURIComponent(
      url
    )}&embedded=true`;
  }, [url]);

  const updateIframeSrc = useCallback(() => {
    if (iframeRef.current) {
      iframeRef.current.src = getIframeLink();
      setShowLoading(true);
    }
  }, [getIframeLink]);

  useEffect(() => {
    const intervalId = setInterval(updateIframeSrc, 1000 * 3);
    setIframeTimeoutId(intervalId);

    return () => {
      clearInterval(intervalId);
    };
  }, [updateIframeSrc]);

  function iframeLoaded() {
    setShowLoading(false);
    clearInterval(iframeTimeoutId);
  }

  return (
    <>
      {showLoading && (
        <div className={`${ComponentStyle.CvLoader}`}>{t("loading")}</div>
      )}
      <iframe
        title="Candidate Document"
        onLoad={iframeLoaded}
        onError={updateIframeSrc}
        ref={iframeRef}
        style={
          showLoading
            ? { display: "none" }
            : {
                display: "block",
                width: "100%",
                height: `${isPublic ? "100vh" : "100%"}`,
              }
        }
        src={getIframeLink()}
      />
    </>
  );
}

// export default IframeGoogleDoc;
